import dayjs from '@/lib/dayjs'
export const returnDate = () => {
  return dayjs().format('DD-MMM-YYYY HH:mm')
}
// Return the current site based on the current hostname
export const getSite = () => {
  if (document.location.hostname === 'www.trailfinders.ie') {
    return 'ie'
  }
  return 'com'
}

// Process email submission from assistance and etrail-assistance modals
export const processResponse = (status) => {
  if (status === 'validationError') {
    const data = {
      errorClass: 'alert alert-danger',
      errorMessage: 'Please ensure the required fields are completed',
      showErrorMessage: true
    }
    return data
  }

  if (status === 'sendError') {
    const data = {
      errorClass: 'alert alert-danger',
      errorMessage: 'There was an error submitting the form',
      showErrorMessage: true
    }
    return data
  }

  if (status === 'success') {
    const data = {
      errorClass: 'alert alert-success',
      errorMessage: 'Message sent.',
      showErrorMessage: true
    }
    return data
  }
}
export const titleCase = (str) => {
  const splitStr = str.toLowerCase().split(' ')
  for (let i = 0; i < splitStr.length; i++) {
    // You do not need to check if i is larger than splitStr length, as your for does that for you
    // Assign it back to the array
    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1)
  }
  // Directly return the joined string
  return splitStr.join(' ')
}

export const getTravellingPassengers = (travellingNamesArray, bookingNames) => {
  // travellingNamesArray is from booking.user_information.names getter -> array of only travelling passengers
  // bookingNames is from booking/getBookingPassenger getter -> includes all names on booking
  let fao = {}
  bookingNames.forEach((item) => {
    if (!travellingNamesArray.includes(`${item.title} ${item.name}`)) {
      fao = item
    }
  })
  return bookingNames.filter((item) => item.name !== fao.name
    && !item.title.includes('FAO')
  )
}

export const addCdnImageWidth = (url, width = 600) => {
  if (!url || typeof url !== 'string') return url
  if (url.startsWith('https://cdn.trailfinders.com/images') && !url.includes('width=')) {
    return `${url}?width=${width}`
  }
  return url
}
